export const parseErrorMessage = (error) => {
	if (!error) return "Unknown error occurred.";

	if (error?.response?.data?.message) return error?.response?.data?.message;
	if (error?.response?.data?.error) return error?.response?.data?.error;
	if (typeof error?.response?.data === "string") return error.response.data;
	// console.log(error, "sdmfbmsad ");
	// Handle Sequelize Errors
	if (error.name && error.name.startsWith("Sequelize")) {
		const errorCode = error.original?.code || error.parent?.code || "No error code provided";
		switch (error.name) {
			case "SequelizeValidationError":
				return `Validation Error: ${error.errors.map((err) => err.message).join(", ")}`;
			case "SequelizeUniqueConstraintError":
				return `Unique Constraint Error: ${error.errors.map((err) => err.message).join(", ")}. Code: ${errorCode}`;
			case "SequelizeForeignKeyConstraintError":
				return `Foreign Key Constraint Error: Ensure referenced key exists. Code: ${errorCode}`;
			case "SequelizeDatabaseError":
				return `Database Error: ${error.message}. Code: ${errorCode}`;
			case "SequelizeConnectionError":
				return `Connection Error: ${error.message}. Code: ${errorCode}`;
			case "SequelizeTimeoutError":
				return `Timeout Error: ${error.message}. Code: ${errorCode}`;
			default:
				return `Sequelize Error: ${error.message}. Code: ${errorCode}`;
		}
	}
	// Handle Built-in JavaScript Errors
	if (error instanceof SyntaxError) {
		return `Syntax Error: ${error.message}`;
	} else if (error instanceof ReferenceError) {
		return `Reference Error: ${error.message}`;
	} else if (error instanceof TypeError) {
		return `Type Error: ${error.message}`;
	} else if (error instanceof RangeError) {
		return `Range Error: ${error.message}`;
	} else if (error instanceof URIError) {
		return `URI Error: ${error.message}`;
	} else if (error instanceof EvalError) {
		return `Eval Error: ${error.message}`;
	}

	// Generic Fallback for Unhandled Errors
	return `Error: ${error.message || String(error)}`;
};
// export default parseErrorMessage;
